export default function StatusBadge({ status }) {
  const map = {
    pending:    { label: "Pending",    cls: "bg-secondary text-muted-foreground border border-border" },
    generating: { label: "Generating", cls: "bg-blue-soft text-blue border border-[hsl(var(--info))/0.2]" },
    completed:  { label: "Completed",  cls: "bg-teal-soft text-teal border border-[hsl(var(--teal))/0.2]" },
    failed:     { label: "Failed",     cls: "bg-destructive/10 text-destructive border border-destructive/30" },
  };
  const m = map[status] || map.pending;
  return (
    <span className={`inline-flex items-center text-[10px] uppercase tracking-wider font-bold px-2 py-1 rounded-full ${m.cls}`} data-testid={`status-${status}`}>
      {status === "generating" && <span className="mr-1.5 inline-block h-1.5 w-1.5 rounded-full bg-current animate-pulse" />}
      {m.label}
    </span>
  );
}
